export const accountReadQueryKeys = {
  all: ["account-read"] as const,
  unread: (ownerId?: string) =>
    [...accountReadQueryKeys.all, "unread", ownerId ?? ""] as const,
  allUnread: () => [...accountReadQueryKeys.all, "unread"] as const,
  detail: (reportId: string | null) =>
    [...accountReadQueryKeys.all, "detail", reportId ?? ""] as const,
  watches: (reportId: string) =>
    [...accountReadQueryKeys.all, "watches", reportId] as const,
};
